import { API_BASE } from "@/shared/config/constants";

export class ApiError extends Error {
  constructor(message, options = {}) {
    super(message);
    this.name = "ApiError";
    this.status = options.status ?? null;
    this.payload = options.payload ?? null;
    this.url = options.url ?? null;
  }
}

export async function authRequest(path, options = {}) {
  const { json, parseAs = "json", ...init } = options;
  const headers = new Headers(init.headers || {});
  let body = init.body;

  if (!headers.has("accept")) headers.set("accept", "application/json");
  if (json !== undefined) {
    headers.set("content-type", "application/json");
    body = JSON.stringify(json);
  }

  const url = path.startsWith("http") ? path : `${API_BASE}${path}`;
  const response = await fetch(url, {
    credentials: "include",
    ...init,
    headers,
    body,
  });

  const raw = await response.text();
  let payload = raw || null;
  try {
    payload = raw ? JSON.parse(raw) : null;
  } catch {
    // Keep raw text for non-JSON error responses.
  }

  if (!response.ok) {
    const message =
      typeof payload === "object" && payload
        ? payload.message || payload.error || `${response.status} ${response.statusText}`
        : `${response.status} ${response.statusText}`;
    throw new ApiError(message, { status: response.status, payload, url });
  }

  if (response.status === 204 || parseAs === "none") return null;
  if (parseAs === "text") return raw;
  return payload;
}
